import FiltersModal from '@/components/modals/FiltersModal';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { Storage } from '@/enums/storage.enum';
import { isNullable } from '@/utils/isNullable';

/**
 * Mixin filtrów raportów
 *
 * Wymaga zadeklarowanej metody `updateList` o sygnaturze `() => any`
 *
 * @export
 * @param {{settingName: string, storageKey: string}} [options={ settingName: PublicSettings.REPORT_FILTERS, storageKey: Storage.REPORT_FILTERS }]
 * @returns
 */
export function reportFiltersMixin(
  options = { settingName: PublicSettings.REPORT_FILTERS, storageKey: Storage.REPORT_FILTERS }
) {
  return {
    components: { FiltersModal },
    data() {
      return {
        filters: this.getFilters(JSON.parse(this.$store.state.setting.settings[options.settingName].value)),
        showFiltersModal: false
      };
    },

    computed: {
      procedureId() {
        return this.$route.params.procedureId.toString();
      }
    },

    methods: {
      // @vuese
      // Zwraca listę wybranych filtrów
      getFilters(availableFilters) {
        const storageFiltersJSON = sessionStorage.getItem(
          options.storageKey + this.$route.params.procedureId.toString()
        );
        if (storageFiltersJSON) {
          const storageFilters = JSON.parse(storageFiltersJSON);
          return availableFilters.map(filter => {
            const storageFilterMatch = storageFilters.filter(storageFilter => storageFilter.name === filter.name);
            const storageFilterExactMatch =
              storageFilterMatch.length === 1
                ? storageFilterMatch[0]
                : storageFilterMatch.find(storageFilter => storageFilter.title === filter.title);

            if (!isNullable(storageFilterExactMatch?.value)) {
              filter.value = storageFilterExactMatch.value;
            } else if (isNullable(filter.value)) {
              filter.value = null;
            }
            return filter;
          });
        }

        return availableFilters.map(filter => {
          if (isNullable(filter.value)) {
            filter.value = null;
          }
          return filter;
        });
      },

      // @vuese
      // Otwiera modala z filtrami
      openFiltersModal() {
        this.showFiltersModal = true;
      },

      // @vuese
      // Zapisuje filtry
      saveFilters(filters) {
        this.filters = filters;
        sessionStorage.setItem(options.storageKey + this.procedureId, JSON.stringify(this.filters));
        this.updateList();
        this.closeFiltersModal();
      },

      // @vuese
      // Zamyka modala z filtrami
      closeFiltersModal() {
        this.showFiltersModal = false;
      }
    }
  };
}
